import FlexDefault from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import BaseIconmoon from '@deprecated-ui/common/Iconmoon';
import BaseInput from '@deprecated-ui/common/Input';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';
import { Carousel as AntdCarousel, Form, Row } from 'antd';
import Image from 'global/Image';

export const Flex = FlexDefault;

export const PageContainer = styled(FlexDefault)`
  width: 100%;
  overflow-y: hidden;
  position: relative;
  margin-top: 60px;
  height: calc(100vh - 60px);

  @media ${device.tablet} {
    margin-top: 103px;
    height: calc(100vh - 103px);
  }
`;

export const CarouselContainer = styled(FlexDefault)`
  display: none;

  @media ${device.tablet} {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: #5dcbad26;
    padding: 30px;
    height: calc(100vh - 60px);
    max-height: 100%;
    width: ${(props) => (props.width ? props.width : '100%')};
  }
`;

export const RightSection = styled(FlexDefault)`
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  background: ${color.light};
  padding: 30px;
  overflow-y: auto;

  @media ${device.tablet} {
    /* height: 95vh;
    max-height: 100%; */
    height: calc(100vh - 101px);
    width: ${(props) => (props.width ? props.width : '100%')};
  }
`;

export const VirtualButtonContainer = styled.div`
  width: 100%;
  max-width: 300px;
  margin-bottom: 50px;

  @media ${device.tablet} {
    display: none;
  }
`;

export const Carousel = styled(AntdCarousel)`
  margin-bottom: 50px;
  height: 100%;
  max-height: 550px;
  margin-top: 23%;

  .slick-dots {
    width: auto;
    bottom: -60px;

    li {
      width: unset;
    }

    li button {
      background: gray;
      width: 5px;
      height: 5px;
      border-radius: 10px;

      &::before {
        display: none;
      }
    }

    li.slick-active button {
      width: 25px;
      height: 5px;
      background: ${color.primary};
      border: unset;
    }
  }
`;

export const CarouselItemContainer = styled(FlexDefault)`
  width: 240px;
  margin: auto;
`;

export const CarouselImage = styled(Image)`
  margin: 0 auto 25px;
  width: 180px;
  height: 180px;
`;

export const VirtualButton = styled(Button)`
  margin: 20px auto;
  padding: 10px 15px;
  border-radius: 10px;
  background: transparent;

  img {
    margin-right: 10px;
  }
`;

export const LoginButton = styled(Button)`
  border-radius: 5px;
  width: 100%;
  margin: 5px 0;

  @media ${device.tablet} {
    width: 268px;
  }
`;

export const RegisterButton = styled(Button)`
  border-radius: 5px;
  width: 100%;
  margin: 5px 0;
  padding: 6px;
  border: 1px solid ${color.primary};

  @media ${device.tablet} {
    width: 268px;
  }
`;

export const Input = styled(BaseInput)``;

export const InputPINForm = styled(Form)`
  &
    .ant-form-item-has-error
    .ant-input-affix-wrapper-focused.securities-input-pin,
  & .ant-form-item-has-error .ant-input-affix-wrapper,
  & .ant-form-item-has-error .securities-input-pin:hover {
    border-color: ${color.sunsetOrange} !important;
    box-shadow: none;
  }

  & .ant-form-item-explain.ant-form-item-explain-error {
    margin-top: 4px;
    min-height: 19px;

    div {
      display: flex;
      align-items: center;
      font-size: 12px;
      line-height: 1.5;
      color: ${color.sunsetOrange};
    }
  }
`;

export const InputPINContainer = styled.div`
  position: relative;

  .eye {
    position: absolute;
    right: 10px;
    width: 16px;
    cursor: pointer;
  }

  .withdrawal-input-pin {
    padding: 0;

    &.ant-input-affix-wrapper {
      padding: 0;
      margin-bottom: 4px;
    }

    .ant-input-prefix {
      background: ${color.light};
      margin-right: 12px;
      padding: 11px;
      border-right: 1px solid ${color.gainsboro};
    }
  }

  .ant-input-group-addon {
    background: ${color.light};
  }

  .securities-input-pin {
    margin: 15px 0 5px;
    height: 35px;
    padding-left: 45px;

    &::placeholder {
      font-family: var(--bold-font);
      color: #e4e4e4;
    }

    &.ant-input-affix-wrapper-focused {
      border-color: ${color.primary};
      box-shadow: none;
    }
  }

  .ant-input-group .ant-input {
    width: 85%;
  }

  .icon-password.input-prefix {
    position: absolute;
    top: 15px;
    left: 0;
    width: 35px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    border-right: 1px solid ${color.gainsboro};
    z-index: 2;
  }
`;

export const RegisterContainer = styled(FlexDefault)`
  border: 1px solid ${color.gainsboro};
  height: 585px;
  max-width: 798px;
  margin: 20px auto;
  background: ${color.downgray};
`;

export const BannerRegisterContainer = styled.div`
  display: none;
  position: relative;
  width: 40%;
  padding: 20px;

  img {
    position: absolute;
    right: 0;
    top: 170px;
  }

  @media ${device.tablet} {
    display: block;
  }
`;

export const BackButton = styled(Button)`
  position: absolute;
  top: 20px;
  left: 20px;
  height: 35px;
  padding: 20px;
  border: 1px solid ${color.primary};
  border-radius: 3px;
`;

export const InfoRegisterContainer = styled(FlexDefault)`
  position: relative;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 0px 40px;
  border-left: 1px solid ${color.gainsboro};
  height: 100%;
  background: ${color.light};
`;

export const Iconmoon = styled(BaseIconmoon)`
  &:before {
    color: ${color.primary} !important;
  }
`;

export const GrayBackButton = styled(BaseIconmoon)`
  display: block;
  position: absolute;
  top: 25px;
  left: 20px;
  @media ${device.tablet} {
    display: none;
  }
`;

export const ContainerTemplateWrapper = styled(Row)<{
  width?: number | string;
}>`
  background-color: ${color.light};
  border: 1px solid ${color.gainsboro};
  margin: 0 auto;
  height: fit-content;
  border-radius: 4px;
  width: ${({ width }) => {
    if (typeof width === 'number') return `${width}px`;
    return width;
  }};

  &.deposit-section-instruction {
    border: none;
    border-radius: 0;
    min-height: 100%;

    i.icon-up-arrow {
      transform: rotate(-90deg);
      font-size: 14px;
      color: ${color.midgray};
    }
  }

  .header {
    height: 56px;
    padding: 0 20px;
    border-bottom: 1px solid ${color.gainsboro};

    p {
      margin-bottom: 0;
    }

    .back-btn {
      background: none;
      border: none;
      min-width: 30px;
      width: fit-content;
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0;
    }

    .title {
      font-family: var(--bold-font);
      font-size: 18px;
      line-height: 24px;
      text-align: center;
      color: ${color.highempahis};
    }

    .right-header {
      text-align: right;

      .history-link {
        font-size: 18px;
        line-height: 24px;
        text-align: right;
        color: ${color.primary};
      }
    }
  }
`;

export const UserRdnInfoContainer = styled(Row)<{ padding?: string | number }>`
  flex-wrap: nowrap;
  border: 1px solid ${color.downgray};
  border-radius: 4px;
  padding: ${({ padding }) => {
    if (padding) {
      if (typeof padding === 'number') return `${padding}px`;
      return padding;
    }

    return '16px 24px';
  }};
  text-align: left;

  img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 20px;
  }

  .text-content {
    flex-grow: 1;
    font-size: 14px;
    line-height: 19px;
    padding: 0 16px;
    overflow: hidden;

    p {
      margin-bottom: 0;
      line-height: 21px;
    }

    .rdn-name {
      color: ${color.highgray};
      word-break: break-word;
      margin-bottom: 4px;
    }

    .rdn-account {
      font-family: var(--bold-font);
      color: ${color.highempahis};
      font-size: 13.5px;
    }
  }

  .btn-copy {
    background-color: #ebf6ef;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.02em;
    color: ${color.primary};
    padding: 8px 10px;
    border-radius: 4px;
    border: none;
    font-family: var(--bold-font);
  }
`;

export const ProfileLabel = styled.label`
  margin-right: 16px;
  width: 30%;
  color: ${color.highempahis};
`;

export const ProfileInputGroup = styled(FlexDefault)`
  align-items: center;
  margin: 25px 0;
  width: 100%;

  &.small-margin {
    margin: 5px 0;
  }
`;

export const InputTokenContainer = styled(FlexDefault)`
  .input-token {
    border: 1px solid ${color.gainsboro};
    height: 36px;
    input {
      border: none;
      font-size: 16px;
      padding: 5px;
    }
  }
`;
